import { useEffect, useState } from "react";
import "../css/QtySelector.css";

// Selettore quantità delle varianti: "+" tondo a quantità 0, pillola "− n +" da 1 in su.
// checkVariants() in Variants.js legge .qty[data-qty] e abilita il "+" con la classe "enabled" sul button.plus.
function QtySelector({ variant, onChange }) {
	const [qty, setQty] = useState(parseInt(variant.is_default > 0) ? 1 : 0);

	useEffect(() => {
		onChange();
	}, [qty]);

	const increment = (e) => {
		e.preventDefault();
		if (e.currentTarget.classList.contains("enabled")) setQty(qty + 1);
	};

	const decrement = (e) => {
		e.preventDefault();
		setQty(qty > 0 ? qty - 1 : 0);
	};

	return (
		<div className={"qty-selector variant-qty" + (qty > 0 ? " active" : "")}>
			{qty > 0 && (
				<button type="button" onClick={decrement} className="minus enabled" aria-label="-">
					−
				</button>
			)}
			<div className="qty" data-qty={qty}>
				{qty}
			</div>
			<button type="button" onClick={increment} className="plus" aria-label="+">
				+
			</button>
		</div>
	);
}

export default QtySelector;
